import axios from "axios";
let getController: any;
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    //Authorization: process.env.REACT_APP_AUTHORIZATION_TOKEN,
  },
});

class ProviderClass {
  URLS = { BASE_URL: process.env.REACT_APP_CHAT_API_URL + "/api" };
  API_URLS = {
    UserFollowing: "user/userfollowinglist",
    UserSuggestion: "user/usersuggestionlist",
    InsertFollowers: "user/insertfollower",
    UserFollowers: "user/userfollowerslist",
    UserCodeNum: "cookie/loggedinucnum",
    UserConnectivityStatus: "user/userconnectivitystatus",
    RecentActivity: "userrecentactivity/inboxrecentactivity",
    DeletAllRecentActivity: "userrecentactivity/allinboxrecentactivityforuser",
    UserRandomSuggestion: "user/userrandomsuggestionlist",
    FavoritePosts: "user/getalllikedposts",
    YourPosts: "user/getallposts",
    InsertMute: "user/inboxmute",
    InsertBlock: "user/insertblock",
    DeleteBlock: "user/deleteblock",
    InsertConversation: "conversations",
    UpdateConversation: "conversations",
    RestartConversation: "conversations/restart",
    DeleteConversation: "conversations/status",
    GetConversationID: "conversations/id",
    GetMessageCount: "messaging/messagecount",
    UpdateMessageReaction: "messaging/reactions",
    UpdateMessageReply: "messaging/messageparent",
    UpdateConversationStatus: "conversations/conversationstatustoapr",
    PinConversation: "conversations/pin",
    UnpinConversation: "conversations/unpin",
    InsertMessage: "messaging",
    GetMessages: "messaging",
    DeleteMessages: "messaging",
    MarkRead: "messaging/markread",
    URLDetails: "messaging/urldetails",
    InboxHistory: "conversations/inboxconversations",
    NewFollowerCount: "user/newfollowercount",
    UpdateNewFollowersCount: "user/updatenewfollowerscount",
    IgnoreEntity: "conversations/ignoreentity",
    Suggestion: "conversations/suggestion",
    StoreNewFollowerCount: "store/storenewfollowercount",
    UpdateStoreNewFollowersCount: "store/updatestorenewfollowerscount",
    StoreFollowers: "store/storefollowerslist",
    DeleteAllPendingRequest: "store/pendingrequest",
    StoreInsertBlock: "store/insertblock",
    StoreDeleteBlock: "store/deleteblock",
    ConversationCount: "conversations/conversationcount",
    YourPostsStore: "store/getallposts",
    MessageHardDelete: "Messaging/messageharddelete",
  };

  async getAllAsync(url: string | undefined, resource: string) {
    getController = new AbortController();
    return await axiosInstance.get<Array<any>>(`${url}/${resource}`, { signal: getController.signal });
  }
  async getAsync(url: string | undefined, resource: string, id: string) {
    getController = new AbortController();
    return await axiosInstance.get<any>(`${url}/${resource}/${id}`, { signal: getController.signal });
  }
  async postAsync(url: string | undefined, resource: string, params?: any) {
    return await axiosInstance({
      method: "post",
      url: `${url}/${resource}`,
      data: params,
    });
  }
  async putAsync(url: string | undefined, resource: string, params?: any) {
    return await axiosInstance({
      method: "put",
      url: `${url}/${resource}`,
      data: params,
    });
  }
  async deleteAsync(url: string | undefined, resource: string, params?: any) {
    return await axiosInstance({
      method: "delete",
      url: `${url}/${resource}`,
      data: params,
    });
  }
  getAll(url: string | undefined, resource: string) {
    getController = new AbortController();
    return axiosInstance.get<Array<any>>(`${url}/${resource}`, { signal: getController.signal });
  }
  get(url: string | undefined, resource: string, id: string) {
    getController = new AbortController();
    return axiosInstance.get<any>(`${url}/${resource}/${id}`, { signal: getController.signal });
  }
  post(url: string | undefined, resource: string, params?: any) {
    return axiosInstance({
      method: "post",
      url: `${url}/${resource}`,
      data: params,
    });
  }
  put(url: string | undefined, resource: string, params?: any) {
    return axiosInstance({
      method: "put",
      url: `${url}/${resource}`,
      data: params,
    });
  }
  delete(url: string | undefined, resource: string, params?: any) {
    return axiosInstance({
      method: "delete",
      url: `${url}/${resource}`,
      data: params,
    });
  }
}

export const cancelGetRequest = () => {
  if (getController) {
    getController.abort();
  }
};

export const stringifyJson = (params: any) => {
  return JSON.stringify(params).replace(/[{}"]/g, "").replace(/:/g, "=").replace(/,/g, "&");
};

export interface ResponseObject {
  code: number;
  status: string;
  data?: any;
  message: string;
}

const Provider = new ProviderClass();
export default Provider;
